<template>
  <div class="form-outline">
    <form-legend :field="field" class="pt-1" />
    <v-textarea
      class="text-area"
      :label="translateLabelIfExist(field)"
      v-model="fieldValue"
      :hint="field.field_options.description"
      persistent-hint
      :rules="getFieldRules({ field, required: field.required })"
      :readonly="readonly"
      clearable
      outlined
      v-bind="darkOrLightMode"
      @input="formUpdated"
      auto-grow
      color="primary-action"
      :height="height"
    >
    </v-textarea>
  </div>
</template>

<script>
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';
import common from '@/mixins/common';

export default {
  components: { FormLegend },
  mixins: [formsMixin, common],
  emits: ['formUpdated'],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  mounted() {
    console.debug(`field=${JSON.stringify(this.field, null, 2)}`);
  },
  data() {
    return {
      fieldValue: this.formModel[this.field.cid] ? this.formModel[this.field.cid] : '',
    };
  },
  computed: {
    height() {
      const heightMapping = { small: '3.5rem', medium: '5.5rem', large: '7.5rem' };
      let size = this.field.field_options && this.field.field_options.size;
      return heightMapping[size] || '60px';
    },
  },
  methods: {
    formUpdated(value) {
      this.$emit('formUpdated', this.field.cid, value);
    },
  },
  watch: {
    formModel(newValue) {
      const value = newValue[this.field.cid] ? newValue[this.field.cid] : '';
      if (this.fieldValue != value) {
        this.fieldValue = value;
      }
    },
  },
};
</script>
<style>
.text-area .v-text-field__slot {
  overflow-y: scroll !important;
}
</style>
